import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Create axios instance with auth token
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export interface MediaGenerateRequest {
  media_type: string;
  countdown_days?: number;
  countdown_text?: string;
  subtitle_text?: string;
  custom_message?: string;
  include_venue: boolean;
  include_date: boolean;
  include_logo: boolean;
  color_theme: string;
}

export interface MediaGenerateResponse {
  media_image: string;
}

export const mediaApi = {
  generateMedia: async (eventId: number, request: MediaGenerateRequest): Promise<MediaGenerateResponse> => {
    const response = await api.post<MediaGenerateResponse>(`/media/generate/${eventId}`, request);
    return response.data;
  },
};